import { Copy } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const CopyIcon = DeckardIconWrapper({ Icon: Copy });
